import { Header } from "../../components/Header";
import { MenuCinema } from "../../components/MenuCinema";

import { Container } from './styles';

export function Cinema(props) {

  const title = "Cinema";

  return (
    <>
      <Header title={title} />

      <Container>
        <MenuCinema />
      </Container>
      
    </>
  );
}